<template>
  <v-container align-start pa-0>
    <v-app-bar app :extended="!$vuetify.breakpoint.lgAndUp">
      <v-app-bar-nav-icon @click.native="$router.go(-1)">
        <v-icon medium>close</v-icon>
      </v-app-bar-nav-icon>

      <v-toolbar-title>
        <span :class="`title  font-weight-bold`">{{ $language.jobDetails['Job Details'] }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <!--TAB HEADERS-->

      <template v-slot:extension v-if="!$vuetify.breakpoint.lgAndUp">
        <v-tabs centered :dark="$vuetify.theme.dark" v-model="tab" grow :show-arrows="$vuetify.breakpoint.xs" :key="index">
          <v-tab href="#Summary">
            <span :class="$vuetify.breakpoint.smAndDown?'caption font-weight-bold':''">{{ $language.jobDetails['Summary'] }}</span>
          </v-tab>
          <v-tab href="#Status" v-show="statusStepper >= 1&&status!=='Applied'">
            <span :class="$vuetify.breakpoint.smAndDown?'caption font-weight-bold':''">{{ $language.jobDetails['Status'] }}</span>
          </v-tab>
        </v-tabs>
      </template>
    </v-app-bar>
    <v-container v-show="loading">
      <v-row justify="center" align="center" class="mt-15">
        <v-col cols="12" justify="center" align="center">
          <v-progress-circular indeterminate :size="70" :width="7" color="primary"></v-progress-circular>
        </v-col>
        <h4 class="grey--text text--darken-3 mt-3">{{ $language.jobDetails['Loading Job Details'] }}</h4>
      </v-row>
    </v-container>
    <v-container pa-0 px-2 v-show="!loading">
      <!--  STATUS TAB -->

      <div v-show="tab==='Status'" v-if="status!=='Applied'">
        <v-row no-gutters justify="center">
          <v-col cols="12" sm="10" lg="12" class="pa-2">
            <log-container :job-key="$route.params.jobId" :is-hefe="isHefe" :job="job" :applicant="applicant"></log-container>
          </v-col>
        </v-row>
      </div>
      <!--Summary-->

      <div v-show="tab==='Summary'">
        <v-container px-1>
          <v-row no-gutters v-if="$vuetify.breakpoint.lgAndUp">
            <v-col cols="8" :class="$vuetify.theme.dark?'border-dark':'border-light'">
              <job-summary :edit-job="job.public" :has-started="hasStarted" summary-view="true" :applicant="applicant" :is-hefe="isHefe" :status="status" @apply="applyDialog = true" @view-bid="applyDialog = true" @withdraw="withdrawDialog = true" @decline="declineDialog = true" @quit="quitDialog = true" :public-view="false"></job-summary>
            </v-col>
            <v-col cols="4" :class="$vuetify.theme.dark?'border-dark':'border-light'">
              <log-container :job-key="$route.params.jobId" :is-hefe="isHefe" :job="job" :pay="false" :applicant="applicant"></log-container>
            </v-col>

          </v-row>
          <v-row no-gutters class="d-flex align-stretch" v-else>
            <v-col cols="12" :class="$vuetify.theme.dark?'border-dark':'border-light'">
              <job-summary :edit-job="job.public" :has-started="hasStarted" summary-view="true" :applicant="applicant" :is-hefe="isHefe" :status="status" @apply="applyDialog = true" @view-bid="applyDialog = true" @withdraw="withdrawDialog = true" @decline="declineDialog = true" @quit="quitDialog = true" :public-view="false"></job-summary>
            </v-col>
          </v-row>

        </v-container>
      </div>

      <!--DIALOGS-->
      <div>

        <v-dialog v-model="shiftStartDialog" persistent max-width="290">
          <v-card class="py-1">
            <v-card-title class="title py-3">{{ $language.jobDetails['Start shift'] }}</v-card-title>
            <v-card-text>{{ $language.jobDetails['Are you sure you want to start this shift?'] }}</v-card-text>
            <v-card-actions class="pt-2 pr-2">
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click.native="shiftStartDialog = false" :disabled="buttonLoading">{{ $language.jobDetails['Cancel'] }}</v-btn>

              <v-btn color="blue" @click.native="handleShiftStart" :disabled="buttonLoading" :loading="buttonLoading" class="">Clock-In</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="endShiftDialog" persistent max-width="290">
          <v-card class="py-1">
            <v-card-title class="title py-3">{{ $language.jobDetails['End this shift?'] }}</v-card-title>
            <v-card-text>{{ $language.jobDetails['Are you sure you want to end this shift?'] }}</v-card-text>
            <v-card-actions class="pt-2 pr-2">
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click.native="endShiftDialog = false" :disabled="buttonLoading">{{ $language.jobDetails['Cancel'] }}</v-btn>
              <v-btn color="primary" class="pr-2" depressed @click.native="endShift" :disabled="buttonLoading" :loading="buttonLoading">{{ $language.jobDetails['Confirm'] }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- DIALOG FOR OBRERO TO APPLY TO A JOB AND CHANGE STATUS TO APPLIED -->
        <v-dialog v-model="applyDialog" persistent max-width="400" style="overflow-x:none">
          <v-card class="py-1" >
            <v-card-title class="title py-3">{{ $language.jobDetails['Apply for this Job?'] }}</v-card-title>
            <v-card-text v-if="!(job.public||{}).bid">{{ $language.jobDetails['Do you want to apply?'] }}</v-card-text>
            <v-card-text v-if="(job.public||{}).bid">
              <v-row no-gutters>
                <v-col cols="12" class="pa-0">
                  <v-form ref="addJobForm" v-model="validForm" lazy-validation>
                    <v-list dense>
                      <v-row no-gutters>
                        <v-col cols="12">
                          <v-row no-gutters class="px-4">

                            <v-col cols="12">
                              <v-text-field ref="rate" v-if="(job.public||{}).rateType==='Hourly'" v-model="bid.rate" type="Number" min="1" outlined flat dense :label="$language.addJob['Pay Rate ($/hr)']" :rules="numberRules">
                                <template v-slot:prepend-inner>
                                  <v-icon class="pr-2">fa-money-bill</v-icon>
                                </template>
                              </v-text-field>
                              <v-text-field ref="fixedCost" v-else v-model="bid.fixedCost" type="Number" min="1" outlined dense flat :rules="numberRules" :label="$language.addJob['Fixed Total ($)']">
                                <template v-slot:prepend-inner>
                                  <v-icon color="primary" class="pr-2">fa-money-bill</v-icon>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-list-item class="px-0 pb-4">
                              <v-list-item-content v-if="job.public.repeat">
                                <v-list-item-subtitle class="subtitle">
                                  Schedule
                                </v-list-item-subtitle>
                                <span>
                                  {{bid.scheduleText}}
                                </span>
                              </v-list-item-content>
                              <v-list-item-content v-else>
                                <v-row no-gutters>
                                  <v-col cols="7" class="pa-0">
                                    <v-list-item-subtitle class="subtitle">
                                      Start Date:
                                    </v-list-item-subtitle>
                                    <span :class="`${$vuetify.breakpoint.xs?'body-1':'headline'} font-weight-bold`">
                                      {{bid.startDate}}
                                    </span>
                                  </v-col>
                                  <v-col cols="5" class="pa-0">
                                    <v-list-item-subtitle class="subtitle">
                                      Start Time:
                                    </v-list-item-subtitle>
                                    <span :class="`${$vuetify.breakpoint.xs?'body-1':'headline'} font-weight-bold`">
                                      {{bid.startTime.h}}:{{bid.startTime.mm}} {{bid.startTime.A}}
                                    </span>
                                  </v-col>
                                </v-row>
                              </v-list-item-content>
                              <v-list-item-action>
                                <v-btn fab small text @click="scheduleOverlay = true">
                                  <v-icon color="primary">fa-edit</v-icon>
                                </v-btn>
                              </v-list-item-action>
                            </v-list-item>
                          </v-row>
                          <v-list-item>
                            <v-list-item-content>
                              <v-textarea ref="description" v-model="bid.jobDesc" outlined flat auto-grow rows="3" :rules="descRules" :label="$language.addJob['Introduction']">
                                <template v-slot:prepend-inner>
                                  <v-icon color="primary" class="pr-3">notes</v-icon>
                                </template>
                              </v-textarea>
                            </v-list-item-content>
                          </v-list-item>
                          <v-row justify="center" class="pt-0" v-if="status==='Applied'">
                            <v-col cols="12" justify="center" align="center">
                              <v-btn color="red" @click="withdrawDialog = true" width="90%">
                                <v-spacer></v-spacer>
                                <span class="white--text pr-4">{{ $language.jobDetails['Withdraw application'] }}</span>
                                <v-spacer></v-spacer>
                                <v-icon color="white">mdi-close-octagon-outline</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-list>
                  </v-form>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="pt-2 pr-5 pb-2">
              <v-row no-gutters align="center" justify="space-around" class="px-2">
                <v-col cols="5">
                  <v-btn color="primary" block text @click.native="applyDialog = false" :disabled="buttonLoading">{{ $language.jobDetails['Cancel'] }}</v-btn>
                </v-col>
                <v-col cols="5" v-if="(job.public||{}).bid">
                  <v-btn color="primary" block depressed @click.native="bidApplication" :loading="buttonLoading">{{ $language.jobDetails['Submit'] }}</v-btn>
                </v-col>
                <v-col cols="5" v-else>
                  <v-btn color="primary" block depressed @click.native="applyJob" :loading="buttonLoading">{{ $language.jobDetails['Submit'] }}</v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>

        </v-dialog>
        <v-dialog v-model="scheduleOverlay" persistent :max-width="(job.public||{}).repeat?450:300">
          <v-card class="pb-2">
            <v-toolbar @click="scheduleOverlay=false" flat>

              <v-toolbar-title> Set Schedule</v-toolbar-title>
            </v-toolbar>
            <schedule :edit-job="bid"></schedule>
            <v-card-actions class="px-4">
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="scheduleOverlay = false">Cancel</v-btn>
              <v-btn color="primary" @click="scheduleOverlay = false">Confirm</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- THIS IS FOR OBRERO TO WITHDRAW HIS APPLICATION -->
        <v-dialog v-model="withdrawDialog" persistent max-width="290">
          <v-card class="py-1">
            <v-card-title class="title py-3">{{ $language.jobDetails['Withdraw this application'] }}</v-card-title>
            <v-card-text>{{ $language.jobDetails['Are you sure? You won\'t be able to apply for this job again if you withdraw your application.'] }}</v-card-text>
            <v-card-actions class="pt-2 pr-2">
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click.native="withdrawDialog = false" :disabled="buttonLoading">{{ $language.jobDetails['Cancel'] }}</v-btn>
              <v-btn color="primary" depressed @click.native="withdrawApplication" :disabled="buttonLoading" :loading="buttonLoading">{{ $language.jobDetails['Withdraw'] }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="startDialog" persistent max-width="290">
          <v-card class="py-1">
            <v-card-title class="title py-3">{{ $language.jobDetails['Start this Job'] }}</v-card-title>
            <v-card-text>{{ $language.jobDetails['Do you want to start this job?'] }}</v-card-text>
            <v-card-actions class="pt-2 pr-2">
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click.native="startDialog = false" :disabled="buttonLoading">{{ $language.jobDetails['Close'] }}</v-btn>
              <v-btn color="primary" text @click.native="startJob" :disabled="buttonLoading" :loading="buttonLoading">{{ $language.jobDetails['Start Job'] }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="completeDialog" max-width="290">
          <v-card class="py-1" v-show="showExpensePrompt">
            <v-card-title class="title py-3">{{ $language.jobDetails['Expenses'] }}</v-card-title>
            <v-card-text>{{ $language.jobDetails['Did you have additional costs or expenses?'] }}</v-card-text>
            <v-card-actions class="pt-2 pr-2">
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click.native="sendExpenses" :disabled="buttonLoading">{{ $language.jobDetails['No'] }}</v-btn>
              <v-btn color="primary" depressed @click.native="handleShowExpensesPrompt" :disabled="buttonLoading" :loading="buttonLoading">{{ $language.jobDetails['Yes'] }}</v-btn>
            </v-card-actions>
          </v-card>
          <v-form v-model="expensesForm" ref="expensesForm">
            <v-card class="py-1" v-show="showExpensesForm">
              <v-card-title class="title py-3">{{ $language.jobDetails['Expenses'] }}</v-card-title>
              <v-card-text>
                <v-layout column fill-height justify-center align-space-around>
                  <v-flex xs12 md5>
                    <span class="subtitle mb-2">{{$language.jobDetails['Add expenses']}} </span>
                    <v-text-field outline v-model="expenses" type="Number" min="0" max="1000000" @focus.native="$event.target.select()"></v-text-field>
                  </v-flex>
                  <v-flex xs12 md5>
                    <span class="subtitle mb-2">{{$language.jobDetails['Expenses summary']}}</span>
                    <v-textarea outline v-model="expensesSummary" rows="4" auto-grow></v-textarea>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions class="pt-2 pr-2">
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click.native="cancelExpenseForm" :disabled="buttonLoading">{{ $language.jobDetails['Cancel'] }}</v-btn>
                <v-btn color="primary" depressed @click="sendExpenses" :disabled="buttonLoading" :loading="buttonLoading">{{ $language.jobDetails['Submit'] }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
          <v-card class="py-1" v-show="!showExpensePrompt&&!showExpensesForm">
            <v-card-title class="title py-3">{{!job.repeat? $language.jobDetails['Complete this Job']: $language.jobDetails['End Shift']}}</v-card-title>
            <v-card-text>{{ !job.repeat?$language.jobDetails['Is this complete?']:$language.jobDetails['Are you sure you want to end this shift?'] }}</v-card-text>
            <v-card-actions class="pt-2 pr-2">
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click.native="cancelExpenseForm" :disabled="buttonLoading">{{ $language.jobDetails['Close'] }}</v-btn>
              <v-btn color="primary" depressed @click.native="completeJob" :disabled="buttonLoading" :loading="buttonLoading">{{ $language.jobDetails['Submit'] }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="quitDialog" max-width="290" transition="dialog-transition">
          <v-card class="py-1">
            <v-card-title class="title py-3">{{ $language.jobDetails['Quit Job?'] }}</v-card-title>
            <v-card-text>{{ $language.jobDetails['Are you sure you want to quit?'] }}</v-card-text>
            <v-card-actions class="pt-2 pr-2">
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click.native="quitDialog = false" :disabled="buttonLoading">{{ $language.jobDetails['Cancel'] }}</v-btn>
              <v-btn color="primary" depressed @click.native="quitJob" :disabled="buttonLoading" :loading="buttonLoading">{{ $language.jobDetails['Quit'] }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <v-snackbar v-model="snackbar.show" :color="snackbar.status === 'error' ? 'error' : 'success'" multi-line :timeout="1500">
        {{ snackbar.message }}
      </v-snackbar>
    </v-container>
  </v-container>

</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'
import {
  object
} from 'rxfire/database'
import {
  map
} from 'rxjs/operators'
import JobSummary from '@/components/common/JobSummary'
// import VueTimepicker from 'vue2-timepicker'
import LogContainer from '@/components/common/log/LogContainer'
import Schedule from '@/components/common/Schedule'
const fb = require('@/services/firebaseConfig.js')
export default {
  props: ['jobRef', 'profileId', 'defaultTab'],
  components: {
    JobSummary,
    // VueTimepicker,
    LogContainer,
    Schedule
  },
  data () {
    return {
      scheduleOverlay: false,
      applicant: {},
      expensesForm: false,
      requiredRule: [
        (v) => (v && v.length < 100) || 'Required field'
      ],
      descRules: [
        (v) => (v && (v || '').length <= 1000) || this.$language.validations['Description should be less than 1000 characters']
      ],

      numberRules: [
        (v) => (/[0-9]|\./).test(v) || this.$language.validations['Only numbers allowed'],
        (v) => (v && v >= 0 && v <= 1000000) || this.$language.validations['Invalid value']
      ],
      expensesReasonDialog: false,
      payment: {
        expenses: 0,
        tip: 0,
        hours: 0,
        compensation: 0
      },
      status: 'New',
      sentExpenses: false,
      expenses: '',
      expensesSummary: '',
      buttonLoading: false,
      loading: false,
      snackbar: {
        show: false,
        message: '',
        status: 'success'
      },
      sub: null,
      job: {
        warnings: {
          All: {}
        },
        applicants: {},
        payments: {
          transactions: {}
        }
      },
      rating: {
        comment: '',
        rating: null,
        ratingDate: new Date()
      },
      profileDialog: false,
      applicantId: null,
      ratingProfileId: null,
      thisProfile: {},
      mini: true,
      drawer: false,
      applyDialog: false,
      quitDialog: false,
      hireDialog: false,
      deleteDialog: false,
      startDialog: false,
      completeDialog: false,
      payProcessDialog: false,
      withdrawDialog: false,
      statusDialog: false,
      endShiftDialog: false,
      endContractDialog: false,
      shiftStartDialog: false,
      manualTimeDialog: false,
      paymentReminderDialog: false,
      hefeFab: false,
      obrFab: false,
      inviteList: [],
      selectAll: '',
      listLength: 0,
      index: 1,
      index2: 2,
      index3: 4,
      menu: false,
      interval: null,
      secondsWorked: 0,
      showExpensePrompt: true,
      showExpensesForm: false,
      paymentId: null,
      selectedShifts: [],
      shiftPayAmount: 0,
      shiftDate: new Date().toISOString().slice(0, 10),
      thisLog: {
        hours: 0,
        reason: ''
      },
      menu1: false,
      menu2: false,
      bidSt: false,
      nowDate: new Date(moment().subtract(1, 'days')).toISOString().slice(0, 10),

      date: new Date(moment().subtract(1, 'days')).toISOString().substr(0, 10),
      clockedIn: null,
      jobLog: null,
      hasPendingShifts: null,
      totalSecondsWorked: 0,
      myMessages: [],
      groupMessages: [],
      messageList: [],
      modal2: false,
      validForm: false,
      bid: {
        contractEndDate: new Date(moment().add(1, 'month')).toISOString().slice(0, 10),
        startDate: new Date(moment()).toISOString().substr(0, 10),
        startTime: {
          h: moment().format('h'),
          mm: '00',
          A: moment().format('A')
        },
        endTime: {
          h: moment().add(60, 'minutes').format('h'),
          mm: '00',
          A: moment().add(60, 'minutes').format('A')
        },
        dayToggle: [],
        monthToggle: []
      },
      timeDrawer: false
    }
  },

  mounted () {
    this.loading = true
    this.sub = object(fb.database.ref(`jobs/${this.$route.params.jobId}/public`))
      .pipe(map(change => ({
        _key: change.snapshot.key,
        ...change.snapshot.val()
      })))
      .subscribe(job => {
        this.job.public = job
        this.shiftPayAmount = this.job.compensation
        this.payment.compensation = this.job.compensation
        this.payment.hours = this.job.hours
        this.index += this.index
        this.index2 += this.index2
        this.loading = false
      })
    this.sub2 = object(fb.database.ref(`jobs/${this.$route.params.jobId}/applicants/${this.currentUser.uid}`))
      .pipe(map(change => ({
        _key: change.snapshot.key,
        ...change.snapshot.val()
      })))
      .subscribe(applicant => {
        if (Object.keys(applicant).length > 1) {
          this.applicant = applicant
          this.status = applicant.status
        } else {
          this.applicant = {}
        }
      })
  },
  destroyed () {
    clearInterval(this.interval)
    this.sub.unsubscribe()
    this.sub2.unsubscribe()
  },
  computed: {
    ...mapState(['userProfile', 'currentUser', 'userJobs', 'openSettings']),
    tab: {
      set (tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } })
        this.index += this.index
      },
      get () {
        return this.$route.query.tab
      }
    },
    isHefe () {
      return ((this.job || {}).public || {}).createdBy === this.currentUser.uid
    },
    hasStripe () {
      var pending = (((this.userProfile || {}).stripeAccount || {}).account || false)
      return pending
    },
    payoutsEnabled () {
      var pending = ((((this.userProfile || {}).stripeAccount || {}).account || {}).payouts_enabled || false)
      return pending
    },
    statusStepper () {
      if (this.status === 'Applied') {
        return 1
      } else if (this.status === 'Approved') {
        return 2
      } else if (this.status === 'Hired' || this.status === 'Started') {
        return 3
      } else if (this.status === 'Completed' || this.status === 'Paid' || this.status === 'Pending Payment') {
        return 4
      } else {
        return -1
      }
    },

    hasStarted () {
      /* eslint-disable */
      var has = []
      Object.keys(((this.job || {}).applicants || {})).map(k => {
        (this.job.applicants[k].status === 'Started' || this.job.applicants[k].status === 'Completed' || this.job.applicants[k].status === 'Pending Payment' || this.job.applicants[k].status === 'Paid') ? has.push(true): 0
      })
      return has.length > 0 ? 1 : 0
      /* eslint-enable */
    },
    compoundProperty () {
      return [this.job.public, this.applicant].join()
    }

  },

  methods: {
    go () {
      this.$router.replace('/')
    },

    editTime () {
      this.thisLog.secondsWorked = parseFloat(this.thisLog.hours) * 3600
      this.thisLog.manualTime = true
      this.thisLog.shiftDate = this.shiftDate ? new Date(moment(this.shiftDate)) : new Date(moment())
      var updates = {}
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/jobLog/${this.thisLog._key}`] = this.thisLog
      fb.database.ref().update(updates)
      this.thisLog = {
        hours: 0,
        reason: ''
      }
      this.index3 = this.index3 + 1
      this.manualTimeDialog = false
    },
    startShiftFixed () {
      var updates = {}

      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/clockedIn`] = true
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/status`] = 'Started'
      updates[`user/${this.currentUser.uid}/jobs/${this.job._key}/status`] = 'Started'

      fb.database.ref().update(updates)
      this.snackbar.message = this.$language.jobDetails['Shift Started']
      this.snackbar.status = 'success'
      this.snackbar.show = true
    },
    completeShiftFixed () {
      var newKey = fb.database.ref().child(`jobs/${this.job._key}/applicants/${this.currentUser.uid}/jobLog`).push().key
      var updates = {}
      var shift = {
        _key: newKey,
        logTitle: 'Shift Completed',
        shiftDate: new Date(),
        status: 'pending',
        expenses: this.job.applicants[this.currentUser.uid].expenses
      }
      var notification = {
        'notificationType': 'Shift Completed',
        'notificationText': [`${this.userProfile.public.name} completed a shift for ${this.job.title}`],
        'notificationDate': new Date(),
        'jobId': this.job._key,
        'defaultTab': 'Payouts'
      }
      updates[`/user/${this.job.createdBy}/profile/notifications/${newKey}`] = notification
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/clockedIn`] = false
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/expenses`] = null
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/status`] = 'Pending Payment'
      updates[`jobs/${this.job._key}/applicants/${this.currentUser.uid}/jobLog/${newKey}`] = shift
      updates[`/user/${this.job.createdBy}/jobs/${this.job._key}/pendingPayment/${this.currentUser.uid}`] = true
      fb.database.ref().update(updates)
      this.snackbar.message = this.$language.jobDetails['Shift Complete']
      this.snackbar.status = 'success'
      this.snackbar.show = true
    },
    handleShowExpensesPrompt () {
      this.showExpensesForm = true
      this.showExpensePrompt = false
      this.expensesSummary = ''
      this.expenses = 0
    },
    cancelExpenseForm () {
      this.showExpensesForm = false
      this.showExpensePrompt = true
      this.expensesSummary = ''
      this.expenses = 0
      this.completeDialog = false
    },
    isRateTypeSelected (option) {
      let original = ['Hourly', 'Fixed']
      return original.indexOf(option) === this.$language.addJob['rateType'].indexOf(this.job.public.rateType)
    },
    sendExpenses () {
      var updates = {}
      this.expenses = this.expenses === '' ? 0 : parseFloat(this.expenses)
      this.expensesSummary = this.expensesSummary === '' ? '' : this.expensesSummary
      updates[`/jobs/${this.job._key}/applicants/${this.currentUser.uid}/expenses`] = {
        reason: this.expensesSummary,
        amount: this.expenses
      }
      fb.database.ref().update(updates)
      this.showExpensesForm = false
      this.showExpensePrompt = false
      this.expensesSummary = ''
      this.expenses = 0
    },
    bidApplication () {
      if (this.$refs.addJobForm.validate()) {
        this.applyJob()
      }
    },
    async applyJob () {
      // There has to be a way for the client to be able to see on the job item if someone applied for his job.
      this.buttonLoading = true
      var updates = {}
      var applicantData = {
        'appliedDate': new Date(),
        'status': 'Applied',
        'profileId': this.currentUser.uid,
        'avatar': this.userProfile.public.photoURL,
        'name': this.userProfile.public.name,
        'mobilePhone': this.userProfile.public.mobilePhone,
        'stripeId': this.userProfile.stripeAccount.stripe_user_id,
        'mlm': this.userProfile.mlm,
        'rating': this.userProfile.public.rating,
        'hefeRated': false
      }
      var jobRef = {
        '_key': this.job.public._key,
        'category': this.job.public.category,
        'title': this.job.public.title,
        'jobDesc': this.job.public.jobDesc,
        'appliedDate': new Date(),
        'bid': this.job.public.bid,
        'repeat': this.job.public.repeat,
        'status': 'Applied',
        'startTime': this.job.public.startTime,
        'endTime': this.job.public.endTime,
        'startDate': this.job.public.startDate,
        'contractEndDate': this.job.public.contractEndDate,
        'rateType': this.job.public.rateType,
        'hours': this.isRateTypeSelected('Hourly') ? this.job.public.hours : -1,
        'compensation': this.isRateTypeSelected('Hourly') ? this.job.public.rate : this.job.public.fixedCost,
        'hefeAvatar': this.job.public.hefeAvatar,
        'hefeName': this.job.public.hefeName,
        'hefeId': this.job.public.createdBy,
        'pictures': this.job.public.pictures ? this.job.public.pictures : null,
        'schedule': this.job.public.schedule ? this.job.public.schedule : null,
        'hefeRating': this.job.public.hefeRating || -1
      }
      if (this.job.public.bid) {
        jobRef.rateType = this.job.public.rateType
        jobRef.compensation = this.isRateTypeSelected('Hourly') ? this.bid.rate : this.bid.fixedCost
        jobRef.hours = this.bid.hours
        applicantData.bid = this.bid
        applicantData.bid.compensation = this.isRateTypeSelected('Hourly') ? this.bid.rate : this.bid.fixedCost
        if (this.isRateTypeSelected('Hourly')) {
          applicantData.bid.rate = this.bid.rate
        } else {
          applicantData.bid.fixedCost = this.bid.fixedCost
        }
        applicantData.bid.startDate = this.bid.startDate
        applicantData.bid.startTime = this.bid.startTime
        applicantData.bid.endTime = this.bid.endTime
        applicantData.bid.contractEndDate = this.bid.contractEndDate
        applicantData.bid.scheduleText = this.bid.scheduleText
        applicantData.bid.schedule = this.bid.schedule
        applicantData.bid.hours = this.bid.hours

        if (this.bid.dayToggle !== undefined) {
          applicantData.bid.dayToggle = this.bid.dayToggle
          jobRef.dayToggle = this.bid.dayToggle
        }
        if (this.bid.monthToggle !== undefined) {
          applicantData.bid.monthToggle = this.bid.monthToggle
          jobRef.monthToggle = this.bid.monthToggle
        }
      }
      var updatedDate = new Date()
      var newKey = await fb.database.ref().child(`/user/${this.job.public.createdBy}/profile/notifications`).push().key
      var notification = {
        'notificationType': 'New Applicant',
        'notificationText': [`\nNew Applicant: ${this.userProfile.public.name} has applied to ${this.job.public.title}.   ${this.job.public.jobShortLink}`],
        'notificationDate': updatedDate,
        'jobId': this.job.public._key,
        'defaultTab': 'Applicants'
      }
      updates[`jobs/${this.job.public._key}/applicants/${this.currentUser.uid}`] = applicantData
      updates[`jobs/${this.job.public._key}/warnings/All/${this.currentUser.uid}`] = false
      updates[`jobs/${this.job.public._key}/warnings/${this.currentUser.uid}`] = false
      updates[`user/${this.currentUser.uid}/jobs/${this.job.public._key}`] = jobRef
      updates[`/user/${this.job.public.createdBy}/profile/notifications/${newKey}`] = notification
      updates[`/user/${this.currentUser.uid}/profile/jobInvites/${this.job.public._key}`] = null
      updates[`/jobs/${this.job.public._key}/public/numberOfApplicants`] = this.job.public.numberOfApplicants ? (this.job.public.numberOfApplicants + 1) : 1
      updates[`/user/${this.job.public.createdBy}/jobs/${this.job.public._key}/numberOfApplicants`] = this.job.public.numberOfApplicants ? (this.job.public.numberOfApplicants + 1) : 1
      await fb.database.ref().update(updates)
      this.buttonLoading = false
      this.applyDialog = false
      this.snackbar.show = true
      // this.tab = 'Status'
      this.snackbar.message = this.$language.jobDetails['You applied for this job.']
    },
    closeDialog () {
      clearInterval(this.interval)
      this.interval = null
      this.$emit('simple-close')
      this.expensesSummary = ''
      this.expenses = 0
      this.cancelExpenseForm()
      if (this.sub !== null) {
        this.sub.unsubscribe()
        this.sub2.unsubscribe()
        this.warnSub.unsubscribe()
      }
      this.secondsWorked = 0
    },
    async startJob () {
      this.buttonLoading = true
      fb.geoFireApp.set(this.job._key, null)
      var updates = {}
      var updatedDate = new Date()
      updates[`/user/${this.currentUser.uid}/jobs/${this.job._key}/status`] = 'Started'
      updates[`/user/${this.currentUser.uid}/jobs/${this.job._key}/updatedDate`] = updatedDate
      updates[`/jobs/${this.job._key}/applicants/${this.currentUser.uid}/status`] = 'Started'
      updates[`/jobs/${this.job._key}/applicants/${this.currentUser.uid}/updatedDate`] = updatedDate
      updates[`/jobs/${this.job._key}/applicants/${this.currentUser.uid}/startedOn`] = updatedDate
      updates[`/user/${this.job.createdBy}/jobs/${this.job._key}/status`] = 'Started'

      var newKey = fb.database.ref().child(`jobs`).push().key
      var notification = {
        'notificationType': 'Job Started',
        'notificationText': `${this.userProfile.public.name} has CLOCKED IN for ${this.job.title}`,
        'notificationDate': updatedDate,
        'jobId': this.job._key,
        'defaultTab': 'Summary'
      }
      updates[`/user/${this.job.createdBy}/profile/notifications/${newKey}`] = notification
      this.buttonLoading = false
      this.startDialog = false
      this.statusDialog = false
      this.snackbar.message = this.$language.jobDetails['You started this job.']
      this.snackbar.show = true
      this.index2 = this.index2 + 1
      await fb.database.ref().update(updates)
    },
    async completeJob () {
      if (!this.job.repeat) {
        this.buttonLoading = true
        fb.geoFireApp.set(this.job._key, null)
        var updates = {}
        var updatedDate = new Date()
        updates[`/user/${this.currentUser.uid}/jobs/${this.job._key}/status`] = 'Pending Payment'
        updates[`/user/${this.currentUser.uid}/jobs/${this.job._key}/updatedDate`] = updatedDate
        updates[`/user/${this.currentUser.uid}/jobs/${this.job._key}/completedOn`] = updatedDate
        updates[`/jobs/${this.job._key}/applicants/${this.currentUser.uid}/status`] = 'Pending Payment'
        updates[`/jobs/${this.job._key}/applicants/${this.currentUser.uid}/updatedDate`] = updatedDate
        // updates[`/user/${this.job.createdBy}/jobs/${this.job._key}/status`] = 'Pending Payment'
        updates[`/user/${this.job.createdBy}/jobs/${this.job._key}/pendingPayment/${this.currentUser.uid}`] = true
        var newKey = fb.database.ref().child(`jobs`).push().key
        var notification = {
          'notificationType': 'Job Completed',
          'notificationText': ['Worker completed your job ', this.job.title],
          'notificationDate': updatedDate,
          'jobId': this.job._key,
          'defaultTab': 'Payouts'
        }
        updates[`/user/${this.job.createdBy}/profile/notifications/${newKey}`] = notification
        await fb.database.ref().update(updates)
        this.buttonLoading = false
        this.completeDialog = false
        this.statusDialog = false
        this.showExpensesForm = false
        this.showExpensePrompt = true
        this.snackbar.message = this.$language.jobDetails['You completed this job.']
        this.snackbar.show = true
        this.index2 = this.index2 + 1
      } else {
        this.completeShiftFixed()
        this.completeDialog = false
        this.showExpensesForm = false
        this.showExpensePrompt = true
      }
    },
    async withdrawApplication () {
      this.buttonLoading = true
      var updates = {}
      updates[`/jobs/${this.job.public._key}/applicants/${this.currentUser.uid}`] = null
      updates[`user/${this.currentUser.uid}/jobs/${this.job.public._key}`] = null
      updates[`user/${this.job.public.createdBy}/jobs/${this.job.public._key}/numberOfApplicants`] = parseInt(this.job.public.numberOfApplicants - 1)
      updates[`/jobs/${this.job.public._key}/public/numberOfApplicants`] = parseInt(this.job.public.numberOfApplicants - 1)

      await fb.database.ref().update(updates)
      this.buttonLoading = false
      this.withdrawDialog = false
      this.snackbar.message = this.$language.jobDetails['You withdrew your application for this job']
      this.snackbar.show = true
      this.$router.replace('/dashboard')
    },
    async quitJob () {
      this.buttonLoading = true
      var updates = {}
      updates[`/jobs/${this.job.public._key}/applicants/${this.currentUser.uid}`] = null
      updates[`user/${this.currentUser.uid}/jobs/${this.job.public._key}`] = null
      updates[`user/${this.job.public.createdBy}/jobs/${this.job.public._key}/hiredWorkers`] = parseInt(this.job.public.hiredWorkers - 1)
      updates[`/jobs/${this.job.public._key}/public/hiredWorkers`] = parseInt(this.job.public.hiredWorkers - 1)

      await fb.database.ref().update(updates)
      this.buttonLoading = false
      this.quitDialog = false

      this.$router.replace('/dashboard')
    },
    checkTime () {
      if (this.bid.startDate && this.bid.startTime) {
        var start = moment(`${this.bid.startDate} ${this.bid.startTime.h}:${this.bid.startTime.mm} ${this.bid.startTime.A}`)
        var end = moment(`${this.bid.startDate} ${this.bid.endTime.h}:${this.bid.endTime.mm} ${this.bid.endTime.A}`)
        if (start >= end) {
          var newEnd = moment(`${this.bid.startDate} ${this.bid.startTime.h}:${this.bid.startTime.mm} ${this.bid.startTime.A}`).add(1, 'hour')
          this.bid.endTime = {
            h: newEnd.format('h'),
            mm: newEnd.format('mm'),
            A: newEnd.format('A')
          }
          this.bid.hours = (newEnd.diff(start, 'minutes') / 60)
        } else {
          this.bid.hours = (end.diff(start, 'minutes') / 60)
        }
      }
    }
  },

  watch: {
    compoundProperty () {
      if (this.applicant.bid) {
        this.bid = this.applicant.bid
      } else {
        this.bid.repeat = this.job.public.repeat
        this.bid.bid = this.job.public.bid
        this.bid.startDate = this.job.public.startDate
        this.bid.startTime = this.job.public.startTime
        this.bid.endDate = this.job.public.endDate
        this.bid.endTime = this.job.public.endTime
        this.bid.contractEndDate = this.job.public.contractEndDate
        this.bid.occ = this.job.public.occ
        this.bid.dayToggle = this.job.public.dayToggle ? this.job.public.dayToggle : []
        this.bid.monthToggle = this.job.public.monthToggle ? this.job.public.monthToggle : []
        this.bid.schedule = this.job.public.schedule
        this.bid.scheduleText = this.job.public.scheduleText
        this.bid.title = this.job.public.title
        this.bid.hours = this.job.public.hours
      }
    },
    job () {
      if (this.job.public.createdBy === this.currentUser.uid) {
        this.$router.push(`/hefe/job-details/${this.$route.params.jobId}`)
      }
      if ((((this.userProfile || {}).userType || {}).hefe || false) && this.job.createdBy !== this.currentUser.uid) {
        // this.$router.push(`/dashboard`)
      }
    },
    'payment.expenses': function (val) {
      if (val === '' || parseFloat(val) < 0) {
        this.payment.expenses = 0
      }
    },
    'payment.tip': function (val) {
      if (val === '' || parseFloat(val) < 0) {
        this.payment.tip = 0
      }
    },
    defaultTab () {
      this.tab = this.defaultTab
    },
    selectAll () {
      this.selectAllFavorites(this.selectAll)
    }
  },

  filters: {
    formatName (val) {
      if (val === 'Hefe') {
        return 'Hefe'
      }
      var str = (val || 'N N').split(' ')
      var name = str[0] + ' ' + str[1][0].toUpperCase() + '.'
      return name
    },
    formatDate (val) {
      if (!val) {
        return '-'
      }
      let date = val.toDate()
      return moment(date).fromNow()
    },

    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(val)
      return moment(date).fromNow()
    },
    formatTime (val) {
      return moment(val).format('hh:mm:ss a')
    },
    trimLength (val) {
      if (val.length < 200) {
        return val
      }
      return `${val.substring(0, 200)}...`
    },
    formatHours (val) {
      if (!val) {
        return '-'
      }
      return parseFloat(val / 60 / 60).toFixed(2)
    },
    formatHoursWorked (val) {
      if (!val) {
        return '-'
      }
      val = Math.floor(val / 3600)
      return Math.round(val % 24)
    },
    formatMinWorked (val) {
      if (!val) {
        return '-'
      }
      val = Math.floor(val / 60)
      var str = (Array(1).join('0') + 0).slice(-1) + Math.round(val % 60)
      val = Math.round(val % 60) < 10 ? str : Math.round(val % 60)
      return val
    },
    formatSecWorked (val) {
      if (!val) {
        return '-'
      }
      var str = (Array(1).join('0') + 0).slice(-1) + Math.round(val % 60)
      val = Math.round(val % 60) < 10 ? str : Math.round(val % 60)
      return val
    }
  }
}
</script>
<style>
.custom-toolbar.v-toolbar__content,
.v-toolbar__extension {
  padding: 0px !important;
}

.centered-input input {
  text-align: end;
}

.blur-content {
  filter: blur(5px);
}
</style>
